export interface ResourceSite {
  id: string;
  name: string;
  tagline: string;
  category: string;
  features: string[];
  update: string;
  works: string;
  stability: string;
  free: boolean;
  color: string;
}

export const resourceSites: ResourceSite[] = [
  {
    id: 'r1',
    name: '韩漫屋',
    tagline: '日更最快 · 新作同步首发',
    category: '日更推荐',
    features: ['每日凌晨更新', '韩漫新作同步', '无遮拦高清'],
    update: '每日更新',
    works: '1200+',
    stability: '★★★★★',
    free: true,
    color: '#ff5f2e',
  },
  {
    id: 'r2',
    name: '泡菜漫画网',
    tagline: '全网收录最全的韩漫站',
    category: '资源大全',
    features: ['收录站点最全', '全集在线', '搜索精准'],
    update: '每日更新',
    works: '2400+',
    stability: '★★★★☆',
    free: true,
    color: '#f2c94c',
  },
  {
    id: 'r3',
    name: '首尔漫画汇',
    tagline: '韩漫APP与网页双端',
    category: 'APP/网页',
    features: ['APP+网页双端', '缓存离线看', '更新提醒'],
    update: '每日更新',
    works: '890+',
    stability: '★★★★★',
    free: true,
    color: '#7bab97',
  },
  {
    id: 'r4',
    name: '汉江漫画社',
    tagline: '老牌站 · 稳定不跑路',
    category: '老牌稳定',
    features: ['运营多年稳定', '资源存档完整', '无弹窗干扰'],
    update: '隔日更新',
    works: '760+',
    stability: '★★★★★',
    free: true,
    color: '#ff7a4d',
  },
  {
    id: 'r5',
    name: '梨漫画',
    tagline: '高画质 · 无遮拦无修',
    category: '高清无遮',
    features: ['原图高清', '无遮拦原版', '多线路'],
    update: '每日更新',
    works: '980+',
    stability: '★★★★☆',
    free: true,
    color: '#f5d66b',
  },
  {
    id: 'r6',
    name: '北村漫画馆',
    tagline: '主打情感与治愈系韩漫',
    category: '分类精选',
    features: ['治愈言情精选', '编辑推荐', '每周书单'],
    update: '每周更新',
    works: '530+',
    stability: '★★★★☆',
    free: true,
    color: '#93c0ac',
  },
  {
    id: 'r7',
    name: '青瓦台漫画',
    tagline: '连载最全 · 追更不迷路',
    category: '日更推荐',
    features: ['连载同步最快', '更新日历', '追更订阅'],
    update: '每日更新',
    works: '1050+',
    stability: '★★★★★',
    free: true,
    color: '#ff9a73',
  },
  {
    id: 'r8',
    name: '釜山漫画社',
    tagline: '网页端 · 无需下载即看',
    category: '网页资源',
    features: ['网页直接看', '无需登录', '加载快'],
    update: '每日更新',
    works: '680+',
    stability: '★★★★☆',
    free: true,
    color: '#f8e28f',
  },
  {
    id: 'r9',
    name: '仁川漫画阁',
    tagline: '多线路切换 · 稳定不掉线',
    category: '高清无遮',
    features: ['多线路备用', '缓存阅读', '夜间模式'],
    update: '每日更新',
    works: '840+',
    stability: '★★★★★',
    free: true,
    color: '#7bab97',
  },
  {
    id: 'r10',
    name: '汉阳漫画坊',
    tagline: '剧情向韩漫深度收录',
    category: '分类精选',
    features: ['剧情深度解析', '长篇连载全', '书单整理'],
    update: '每周更新',
    works: '610+',
    stability: '★★★★☆',
    free: true,
    color: '#ff7a4d',
  },
];

export const resourceCategories = [
  { name: '全部', value: 'all' },
  { name: '日更推荐', value: '日更推荐' },
  { name: '资源大全', value: '资源大全' },
  { name: 'APP/网页', value: 'APP/网页' },
  { name: '老牌稳定', value: '老牌稳定' },
  { name: '高清无遮', value: '高清无遮' },
  { name: '分类精选', value: '分类精选' },
  { name: '网页资源', value: '网页资源' },
];